import {
  faCommentDots,
  faExclamationTriangle,
  faRedoAlt,
} from '@fortawesome/free-solid-svg-icons';
import { memo } from 'react';
import Tag from '~/components/ui/Tag';
import {
  DISCUSSION_STATUS_APPROVED,
  DISCUSSION_STATUS_UNMODERATED,
  DiscussionStatus,
} from '~/lib/discussions/types';

interface DiscussionTagProps {
  isOwner: boolean;
  isStaffOrPartner: boolean;
  status: DiscussionStatus;
  partnerHasReplied: boolean;
}

function DiscussionTag({
  isOwner,
  isStaffOrPartner,
  status,
  partnerHasReplied,
}: Readonly<DiscussionTagProps>) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {status === DISCUSSION_STATUS_UNMODERATED &&
        isOwner &&
        !isStaffOrPartner && (
          <Tag label="Pending moderation" faIcon={faRedoAlt} />
        )}
      {status === DISCUSSION_STATUS_UNMODERATED && isStaffOrPartner && (
        <Tag label="Needs moderation" faIcon={faExclamationTriangle} />
      )}
      {status === DISCUSSION_STATUS_APPROVED &&
        isStaffOrPartner &&
        !partnerHasReplied && (
          <Tag
            label="Needs reply"
            variant="brick-light"
            faIcon={faCommentDots}
          />
        )}
    </div>
  );
}

export default memo(DiscussionTag);
